import { useContext } from "react";
import { ThemeContext, type ThemeContextValue } from "../providers/themeProvider.tsx";

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within a ThemeProvider");
  return ctx;
}
